import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const useRedirectIfNotInLocalStorage = (keys, redirectRoute) => {
  const navigate = useNavigate();

  useEffect(() => {
    const missingKeys = keys.some((key) => {
      const item = JSON.parse(localStorage.getItem(key));
      return !localStorage.hasOwnProperty(key) || item === "" || item === null;
    });

    if (!missingKeys) return;

    navigate(redirectRoute);
  }, []);
};

export default useRedirectIfNotInLocalStorage;
